export default class GameBadgeRequirements {
  public participationCount: number;
  public points: number;
  public fromDate: string;
  public toDate: string;
}
